import { Phone } from "lucide-react";
import { WhatsAppIcon } from "@/components/site/WhatsAppIcon";
import { PHONE_TEL, waLink, onCall, onWhatsApp } from "@/lib/site";

// Fixed bottom emergency bar — mobile only. #1 conversion tool.
export const MobileBar = () => {
  return (
    <div
      data-testid="mobile-sticky-bar"
      className="lg:hidden fixed bottom-0 inset-x-0 z-50 grid grid-cols-2 border-t border-white/10 shadow-[0_-8px_30px_rgba(0,0,0,0.6)]"
    >
      <a
        href={`tel:${PHONE_TEL}`}
        data-testid="mobilebar-call"
        onClick={() => onCall("mobile-bar")}
        aria-label="Ligar agora para a DG Guinchos"
        className="flex items-center justify-center gap-2 bg-brand active:bg-brand-hover text-white font-display font-bold uppercase tracking-wide text-base py-4"
      >
        <Phone className="h-5 w-5" /> Ligar Agora
      </a>
      <a
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobilebar-whatsapp"
        onClick={() => onWhatsApp("mobile-bar")}
        aria-label="Falar no WhatsApp com a DG Guinchos"
        className="flex items-center justify-center gap-2 bg-wapp active:bg-wapp-hover text-black font-display font-bold uppercase tracking-wide text-base py-4"
      >
        <WhatsAppIcon className="h-5 w-5" /> WhatsApp 24h
      </a>
    </div>
  );
};
